<div class="w-100">
    @if (showLoader) {
<app-loader></app-loader>
}
     @if (dialogData?.isOpenedFromDashboard) {
<div class="header">
        <div class="d-flex w-100 py-3 px-4">
          <div class="me-2 id flex-fill">
            <h4 class="modal-title mb-0 item-id">
              Proposals - {{ dialogData?.filteredStatus }}
            </h4>
          </div>

          <div class="btns-header">
            <button class="close" (click)="dialogRef.close()" aria-label="Close">
              <i class="fas fa-times" title="Close Popup"></i>
            </button>
            <!-- <button class="close expand-modal" (click)="expandCollapse()">
              <i class="fas ms-2 me-2" style="font-weight: bold;" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
              [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
            </button> -->
          </div>
        </div>
    </div>
}
        <!-- <a href="javascript:;" (click)="openLeaseRateCalculator()"> Lease Rate Calculator</a> -->

    @if (showGrid) {
<ejs-grid
        #proposalGrid
        [id]="gridName"
        [dataSource]="dataSource"
        [allowPaging]="true"
        [pageSettings]="{ pageSizes: [20, 50, 100, 500], pageSize: 20 }"
        [gridLines]="false"
        [allowFiltering]="true"
        [query]="query"
        [showColumnChooser]="true"
        [height]="gridHeight"
        [allowSorting]="true"
        [enableHover]="false"
        [allowResizing]="true"
        [allowReordering]="true"
        [allowExcelExport]="true"
        [enablePersistence]="true"
        [allowSelection]="true"
        [sortSettings]="sortOptions"
        [searchSettings]="searchSettings"
        [editSettings]="{ allowEditing: false }"
        [filterSettings]="{ type: 'Menu' }"
        (toolbarClick)="onToolbarClick($event)"
        (rowDataBound)="onRowDataBound($event)"
        (commandClick)="commandClick($event, proposalGrid)"
        (created)="created()"
        (actionComplete)="onGridActionComplete($event, proposalGrid)"
        (dataBound)="dataBound($event)"
        >
        <e-columns>
            @for (column of columns; track column) {
<e-column
               
                [field]="column.field"
                [headerText]="column.headerText"
                [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
                [type]="column.type"
                [width]="column.width"
                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                [format]="column.format ? column.format : null"
                [textAlign]="column.textAlign"
                [showInColumnChooser]="column.showInColumnChooser"
                [visible]="column.visible"
                [commands]="column?.commands ? column.commands : null"
                [edit]="column.edit"
                [allowReordering]="column.allowReordering ?? true"
                [freeze]="column.freeze ? column.freeze: null"
                [allowEditing]="column.allowEditing"
                [allowSorting]="column.allowSorting ?? true"
                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                @if (column.field === 'statusText') {
<ng-template #template let-data>
                  <span class="grid-status-column" [ngStyle]="{'background-color': data.statusColorCode}">{{data.statusText}}</span>
                </ng-template>
}
                @if (column.field === 'proposalId') {
<ng-template #template let-data>
                  <i class="fas" [ngClass]="{ 'fa-circle-check color-green': data.isActive, 'fa-ban color-red': !data.isActive }" [title]="data.isActive ? 'Active': 'Inactive'"></i>
                  <a href="javascript:" (click)="openProposalPopup(null, null, data.proposalId)">
                    {{ data.proposalId }}
                  </a>
                </ng-template>
}
                <!-- <ng-template *ngIf="column.field === 'customer'" #template let-data>
                  {{data?.customerId +" - "+ data.customer}}
                </ng-template> -->
                @if (column.field === 'customer') {
<ng-template #template let-data>
                  <a href="javascript:" (click)="openProspectPopup(data.customerId)">
                    {{ data.customer }}
                  </a>
                </ng-template>
}
                @if (column.field === 'salesLeadId') {
<ng-template #template let-data>
                  <a href="javascript:" (click)="openLeadsPopup(data.salesLeadId)">{{data.salesLeadId}}</a>
                </ng-template>
}
                @if (column.field === 'opportunityId') {
<ng-template #template let-data>
                  <a href="javascript:" (click)="openOpportunityPopup(data.opportunityId)">{{data.opportunityId}}</a>
                </ng-template>
}
                @if (column.field === 'accountName') {
<ng-template #template let-data>
                  @if (data.accountName) {
<a href="javascript:" (click)="openDistributorPopup(data)">{{data.accountName}}</a>
}
                </ng-template>
}
            </e-column>
}
        </e-columns>
    </ejs-grid>
}
  </div>

  <ng-template #columnChooser>
    <app-column-chooser
        [grid]="grid"
    ></app-column-chooser>
  </ng-template>

  <ng-template #addLeads>
    @if (rolePermissions['proposalGrid_add']?.visible) {
<i class="fas fa-add"></i>
}
  </ng-template>

  @if (showProspectsPopup) {
<app-proscpects-popup
 
    [prospectData]="prospectData"
    [tab]="'details'"
    (onClose)="showProspectsPopup = false"
    >
  </app-proscpects-popup>
}
